import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createBlock as _createBlock, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f10fb6bc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    "color": "white"
  }
};
const _hoisted_2 = {
  key: 0,
  class: "eventDetailPanelTitle"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "background-color": "#005FF5"
  }
}, " ", -1));
const _hoisted_4 = {
  key: 0,
  class: "eventDetailPanelContentItem"
};
const _hoisted_5 = {
  class: "eventDetailPanelContentItemTitle"
};
const _hoisted_6 = {
  key: 1,
  class: "eventDetailPanelContentItem"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "eventDetailPanelContentItemTitle"
}, " ", -1));
const _hoisted_8 = {
  key: 2,
  class: "eventDetailPanelContentItem"
};
const _hoisted_9 = {
  class: "eventDetailPanelContentItemTitle"
};
const _hoisted_10 = {
  class: "eventDetailPanelContentItemContent"
};
const _hoisted_11 = {
  key: 3,
  class: "eventDetailPanelContentItem"
};
const _hoisted_12 = {
  class: "eventDetailPanelContentRequiredMark"
};
const _hoisted_13 = {
  class: "eventDetailPanelContentItemTitle"
};
const _hoisted_14 = {
  class: "eventDetailPanelContentItemContent"
};
const _hoisted_15 = {
  key: 4,
  class: "eventDetailPanelContentItem"
};
const _hoisted_16 = {
  class: "eventDetailPanelContentRequiredMark"
};
const _hoisted_17 = {
  class: "eventDetailPanelContentItemTitle"
};
const _hoisted_18 = {
  class: "eventDetailPanelContentItemContent"
};
const _hoisted_19 = {
  key: 5,
  class: "eventDetailPanelContentItem"
};
const _hoisted_20 = {
  class: "eventDetailPanelContentRequiredMark"
};
const _hoisted_21 = {
  class: "eventDetailPanelContentItemTitle"
};
const _hoisted_22 = {
  class: "eventDetailPanelContentItemContent"
};
const _hoisted_23 = {
  key: 6,
  class: "eventDetailPanelContentItem"
};
const _hoisted_24 = {
  class: "eventDetailPanelContentRequiredMark"
};
const _hoisted_25 = {
  class: "eventDetailPanelContentItemTitle"
};
const _hoisted_26 = {
  class: "eventDetailPanelContentItemContent"
};
const _hoisted_27 = {
  key: 7,
  class: "eventDetailPanelContentItem"
};
const _hoisted_28 = {
  class: "eventDetailPanelContentRequiredMark"
};
const _hoisted_29 = {
  class: "eventDetailPanelContentItemTitle"
};
const _hoisted_30 = {
  class: "eventDetailPanelContentItemContent"
};
const _hoisted_31 = {
  key: 8,
  class: "eventDetailPanelContentItem"
};
const _hoisted_32 = {
  class: "eventDetailPanelContentRequiredMark"
};
const _hoisted_33 = {
  class: "eventDetailPanelContentItemTitle"
};
const _hoisted_34 = {
  class: "eventDetailPanelContentItemContent"
};
const _hoisted_35 = {
  key: 9,
  class: "eventDetailPanelContentItem"
};
const _hoisted_36 = {
  class: "eventDetailPanelContentRequiredMark"
};
const _hoisted_37 = {
  class: "eventDetailPanelContentItemTitle"
};
const _hoisted_38 = {
  class: "eventDetailPanelContentItemContent"
};
const _hoisted_39 = {
  key: 10,
  class: "eventDetailPanelContentItem"
};
const _hoisted_40 = {
  class: "eventDetailPanelContentRequiredMark"
};
const _hoisted_41 = {
  class: "eventDetailPanelContentItemTitle"
};
const _hoisted_42 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "#CCCCCC"
  }
}, "支持.jpg、.png、.gif、.mp4等常见格式", -1));
const _hoisted_43 = {
  key: 0
};
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "red"
  }
}, "上传中...请稍等", -1));
const _hoisted_45 = [_hoisted_44];
const _hoisted_46 = {
  key: 11,
  class: "eventDetailPanelContentItem"
};
const _hoisted_47 = {
  class: "eventDetailPanelContentItemTitle"
};
const _hoisted_48 = {
  class: "eventDetailPanelContentItemLink"
};
const _hoisted_49 = ["href"];
const _hoisted_50 = {
  key: 12,
  class: "eventDetailPanelContentItem"
};
const _hoisted_51 = {
  class: "eventDetailPanelContentItemTitle"
};
const _hoisted_52 = ["src"];
const _hoisted_53 = {
  style: {
    "width": "100%",
    "text-align": "center"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_svg_icon = _resolveComponent("svg-icon");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_tag = _resolveComponent("el-tag");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_cascader = _resolveComponent("el-cascader");
  const _component_el_tree = _resolveComponent("el-tree");
  const _component_Plus = _resolveComponent("Plus");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createBlock(_component_el_dialog, {
    modelValue: $data.dialogVisible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.dialogVisible = $event),
    width: $data.detail.width ? $data.detail.width : '40%',
    onClose: $options.onDialogClose,
    "show-close": false
  }, {
    header: _withCtx(() => [_createVNode(_component_el_row, {
      style: {
        "background-color": "#005FF5"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 8
      }), _createVNode(_component_el_col, {
        span: 8,
        style: {
          "text-align": "center",
          "padding": "10px 0"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("span", _hoisted_1, _toDisplayString($data.detail.title), 1)]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8,
        style: {
          "align-self": "center",
          "text-align": "right",
          "padding": "10px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_svg_icon, {
          "icon-class": 'close',
          style: {
            "cursor": "pointer"
          },
          onClick: _cache[0] || (_cache[0] = $event => $data.dialogVisible = false)
        })]),
        _: 1
      })]),
      _: 1
    })]),
    default: _withCtx(() => [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.detail.details, (d, di) => {
      return _openBlock(), _createElementBlock("li", {
        class: "eventDetailPanel",
        key: 'ed_' + $data.detail.id + '_' + di
      }, [d.title ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_hoisted_3, _createElementVNode("span", null, _toDisplayString(d.title), 1)])) : _createCommentVNode("", true), _createVNode(_component_el_row, null, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(d.items, (item, ii) => {
          return _openBlock(), _createBlock(_component_el_col, {
            span: d.width,
            key: di + '_' + ii,
            style: {
              "margin-bottom": "10px"
            }
          }, {
            default: _withCtx(() => [item.type === 'text' ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString(item.label) + "：", 1), _createElementVNode("span", {
              class: "eventDetailPanelContentItemContent",
              style: _normalizeStyle(item.style)
            }, _toDisplayString(item.value ? item.value : '-'), 5)])) : _createCommentVNode("", true), item.type === 'placeholder' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_hoisted_7, _createElementVNode("span", {
              class: "eventDetailPanelContentItemContent",
              style: _normalizeStyle(item.style)
            }, " ", 4)])) : _createCommentVNode("", true), item.type === 'texts' ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("span", _hoisted_9, _toDisplayString(item.label) + "：", 1), _createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.value, (t, i) => {
              return _openBlock(), _createBlock(_component_el_tag, {
                key: i,
                size: "small",
                style: {
                  "margin": "0 4px"
                }
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(t.text), 1)]),
                _: 2
              }, 1024);
            }), 128))])])) : _createCommentVNode("", true), item.type === 'input' ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("span", _hoisted_12, _toDisplayString(item.required ? '*' : ''), 1), _createElementVNode("span", _hoisted_13, _toDisplayString(item.label) + "：", 1), _createElementVNode("div", _hoisted_14, [_createVNode(_component_el_input, {
              type: item.inputType ? item.inputType : 'text',
              style: {
                "width": "100%"
              },
              modelValue: $data.form[item.name],
              "onUpdate:modelValue": $event => $data.form[item.name] = $event,
              disabled: item.disabled,
              placeholder: item.placeholder
            }, null, 8, ["type", "modelValue", "onUpdate:modelValue", "disabled", "placeholder"])])])) : _createCommentVNode("", true), item.type === 'textarea' ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("span", _hoisted_16, _toDisplayString(item.required ? '*' : ''), 1), _createElementVNode("span", _hoisted_17, _toDisplayString(item.label) + "：", 1), _createElementVNode("div", _hoisted_18, [_createVNode(_component_el_input, {
              type: "textarea",
              style: {
                "width": "300px"
              },
              rows: "5",
              modelValue: $data.form[item.name],
              "onUpdate:modelValue": $event => $data.form[item.name] = $event,
              placeholder: item.placeholder
            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])])])) : _createCommentVNode("", true), item.type === 'datetime' ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("span", _hoisted_20, _toDisplayString(item.required ? '*' : ''), 1), _createElementVNode("span", _hoisted_21, _toDisplayString(item.label) + "：", 1), _createElementVNode("div", _hoisted_22, [_createVNode(_component_el_date_picker, {
              modelValue: $data.form[item.name],
              "onUpdate:modelValue": $event => $data.form[item.name] = $event,
              type: "datetime",
              "value-format": "YYYY-MM-DD HH:mm:ss",
              placeholder: item.placeholder
            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])])])) : _createCommentVNode("", true), item.type === 'select' ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createElementVNode("span", _hoisted_24, _toDisplayString(item.required ? '*' : ''), 1), _createElementVNode("span", _hoisted_25, _toDisplayString(item.label) + "：", 1), _createElementVNode("div", _hoisted_26, [_createVNode(_component_el_select, {
              modelValue: $data.form[item.name],
              "onUpdate:modelValue": $event => $data.form[item.name] = $event,
              disabled: item.disabled,
              multiple: item.multiple,
              onChange: $event => $options.queryDataSource(item.name),
              class: "m-2",
              placeholder: item.placeholder ? item.placeholder : '请选择'
            }, {
              default: _withCtx(() => [item.dataSource ? (_openBlock(true), _createElementBlock(_Fragment, {
                key: 0
              }, _renderList($data.dataSource[item.name], op => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: op.value,
                  label: op.label,
                  value: op.value
                }, null, 8, ["label", "value"]);
              }), 128)) : (_openBlock(true), _createElementBlock(_Fragment, {
                key: 1
              }, _renderList(item.value, op => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: op.value,
                  label: op.label,
                  value: op.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "disabled", "multiple", "onChange", "placeholder"])])])) : _createCommentVNode("", true), item.type === 'multiSelect' ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createElementVNode("span", _hoisted_28, _toDisplayString(item.required ? '*' : ''), 1), _createElementVNode("span", _hoisted_29, _toDisplayString(item.label) + "：", 1), _createElementVNode("div", _hoisted_30, [_createVNode(_component_el_select, {
              modelValue: $data.form[item.name],
              "onUpdate:modelValue": $event => $data.form[item.name] = $event,
              multiple: "",
              disabled: item.disabled,
              onChange: $event => $options.queryDataSource(item.name),
              class: "m-2",
              placeholder: item.placeholder ? item.placeholder : '请选择'
            }, {
              default: _withCtx(() => [item.dataSource ? (_openBlock(true), _createElementBlock(_Fragment, {
                key: 0
              }, _renderList($data.dataSource[item.name], op => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: op.value,
                  label: op.label,
                  value: op.value
                }, null, 8, ["label", "value"]);
              }), 128)) : (_openBlock(true), _createElementBlock(_Fragment, {
                key: 1
              }, _renderList(item.value, op => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: op.value,
                  label: op.label,
                  value: op.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "disabled", "onChange", "placeholder"])])])) : _createCommentVNode("", true), item.type === 'cascader' ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_createElementVNode("span", _hoisted_32, _toDisplayString(item.required ? '*' : ''), 1), _createElementVNode("span", _hoisted_33, _toDisplayString(item.label) + "：", 1), _createElementVNode("div", _hoisted_34, [item.dataSource ? (_openBlock(), _createBlock(_component_el_cascader, {
              key: 0,
              placeholder: item.placeholder ? item.placeholder : '请选择',
              onChange: v => {
                this.form[item.name] = v;
                $options.queryDataSource(item.name);
              },
              modelValue: $data.form[item.name],
              "onUpdate:modelValue": $event => $data.form[item.name] = $event,
              props: {
                emitPath: false,
                multiple: item.multiple,
                checkStrictly: item.checkStrictly,
                lazy: true,
                lazyLoad: (n, s) => $options.fnLazyLoad(item.name, item.dataSource, n, s)
              },
              disabled: item.disabled,
              "show-all-levels": false
            }, null, 8, ["placeholder", "onChange", "modelValue", "onUpdate:modelValue", "props", "disabled"])) : (_openBlock(), _createBlock(_component_el_cascader, {
              key: 1,
              modelValue: $data.form[item.name],
              "onUpdate:modelValue": $event => $data.form[item.name] = $event,
              placeholder: item.placeholder ? item.placeholder : '请选择',
              onChange: $event => $options.queryDataSource(item.name),
              disabled: item.disabled,
              props: {
                emitPath: false,
                multiple: item.multiple
              },
              options: item.value,
              "show-all-levels": false
            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "onChange", "disabled", "props", "options"]))])])) : _createCommentVNode("", true), item.type === 'tree' ? (_openBlock(), _createElementBlock("div", _hoisted_35, [_createElementVNode("span", _hoisted_36, _toDisplayString(item.required ? '*' : ''), 1), _createElementVNode("span", _hoisted_37, _toDisplayString(item.label) + "：", 1), _createElementVNode("div", _hoisted_38, [_createVNode(_component_el_tree, {
              style: {
                "border": "#EEEEEE solid 2px",
                "width": "300px"
              },
              "show-checkbox": item.changeable,
              "node-key": item.key,
              data: item.value,
              "highlight-current": "",
              props: item.props,
              "default-expand-all": item.expand,
              "default-checked-keys": $data.form[item.name],
              onCheck: $data.eventActions[item.name]
            }, null, 8, ["show-checkbox", "node-key", "data", "props", "default-expand-all", "default-checked-keys", "onCheck"])])])) : _createCommentVNode("", true), item.type === 'uploadImage' ? (_openBlock(), _createElementBlock("div", _hoisted_39, [_createElementVNode("span", _hoisted_40, _toDisplayString(item.required ? '*' : ''), 1), _createElementVNode("span", _hoisted_41, _toDisplayString(item.label) + "(" + _toDisplayString(item.limit) + "张)：", 1), _createElementVNode("div", null, [_createVNode(_component_el_upload, {
              "list-type": "picture-card",
              "auto-upload": true,
              limit: item.limit,
              "before-upload": $options.beforeImageUpload,
              "http-request": $options.uploadRequest,
              "file-list": $data.form[item.name + '_init'],
              "on-success": r => $options.handleImageUploadSuccess(item.name, r.url, r),
              "on-remove": d => $options.handleUploadImageRemove(item.name, d)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_component_Plus)]),
                _: 1
              })]),
              _: 2
            }, 1032, ["limit", "before-upload", "http-request", "file-list", "on-success", "on-remove"]), _hoisted_42, $data.uploading ? (_openBlock(), _createElementBlock("div", _hoisted_43, _hoisted_45)) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), item.type === 'link' ? (_openBlock(), _createElementBlock("div", _hoisted_46, [_createElementVNode("span", _hoisted_47, _toDisplayString(item.label) + "：", 1), _createElementVNode("span", _hoisted_48, [_createElementVNode("a", {
              href: item.link,
              target: "_blank"
            }, _toDisplayString(item.value), 9, _hoisted_49)])])) : _createCommentVNode("", true), item.type === 'images' ? (_openBlock(), _createElementBlock("div", _hoisted_50, [_createElementVNode("div", _hoisted_51, [_createElementVNode("span", null, _toDisplayString(item.label) + "：", 1)]), _createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.images, (img, imgIdx) => {
              return _openBlock(), _createElementBlock("img", {
                key: imgIdx,
                src: img,
                class: "eventDetailPanelContentImg"
              }, null, 8, _hoisted_52);
            }), 128))])])) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["span"]);
        }), 128))]),
        _: 2
      }, 1024)]);
    }), 128))]), _renderSlot(_ctx.$slots, "custom", {
      rowData: $data.detail
    }, undefined, true), _createElementVNode("div", _hoisted_53, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.detail.buttons, (b, i) => {
      return _openBlock(), _createBlock(_component_el_button, {
        onClick: $event => $options.onButtonClick(b.action),
        key: i,
        style: _normalizeStyle(b.style)
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(b.text), 1)]),
        _: 2
      }, 1032, ["onClick", "style"]);
    }), 128))])]),
    _: 3
  }, 8, ["modelValue", "width", "onClose"]);
}